exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".modal-body {\n  overflow: hidden;\n}\n.mr-dropdown .customDropdown .option.expanded {\n  max-height: 12em;\n}\n.address-edit-form {\n  margin-bottom: 2em;\n}\n", ""]);

// exports
